import { ProductOptions } from "../../../../queries/archive";
import _ from "lodash";

export const getProductDetails = (details: ProductOptions) => {
  return _.entries(details).filter(
    item => item[1] !== null && item[0] !== "__typename"
  );
};
